import React, { useEffect, useRef, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { createPortal } from "react-dom";

import { getFilterOptions } from "../../helpers/getTranslatedFilterOptions";
import { TextInputType } from "components/prime-data-table/interfaces/edit-interfaces";
import { FilteringType } from "components/prime-data-table/interfaces";

import styles from "./Filter.module.scss";

interface IFilterTypePopupProps {
    filterType: FilteringType;
    handleFilterTypeChange: Function;
    t: Function;
    type: TextInputType;
    tableRef?: any;
    inputRef?: any;
}

export const FilterTypePopup = ({ filterType, handleFilterTypeChange, t, type, tableRef, inputRef }: IFilterTypePopupProps) => {
    const popUpRef = useRef<HTMLDivElement>(null);
    const buttonRef = useRef<HTMLDivElement>(null);
    const [popUpPosition, setPopUpPosition] = useState<any>({ top: 0, left: 0, width: 0 });

    const [popUpOpen, setPopUpOpen] = useState<boolean>(false);

    const translatedOptions = getFilterOptions(type);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                popUpRef.current &&
                !popUpRef.current.contains(event.target) &&
                !event.target.className.includes("p-dropdown-item") &&
                event.target != buttonRef.current
            )
                closePopUp();
        };

        if (popUpOpen) {
            document.addEventListener("mousedown", handleClickOutside);
            checkPopUpPosition();
        }

        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [popUpOpen]);

    const checkPopUpPosition = () => {
        if (tableRef.current) {
            const tabelWidth = tableRef.current?.offsetWidth;
            const popUpInputWidth = inputRef.current?.offsetWidth;

            const popUpPositionX = inputRef.current?.offsetLeft;
            const popUpWidth = inputRef.current?.offsetWidth > 175 ? inputRef.current?.offsetWidth : 175;

            let _popUpPosition = { left: popUpPositionX, width: popUpWidth };

            if (tabelWidth - (inputRef.current?.offsetLeft + popUpWidth + 6) <= 0) {
                _popUpPosition = { ..._popUpPosition, left: popUpPositionX + (popUpInputWidth - popUpWidth) };
            }

            setPopUpPosition(_popUpPosition);
        }
        return false;
    };

    const closePopUp = () => setPopUpOpen(false);

    const handleChangeFilterType = (e) => {
        const { value } = e.target;
        handleFilterTypeChange(value);
        closePopUp();
    };

    return (
        <>
            <span
                onClick={() => setPopUpOpen((prev) => !prev)}
                className={"pi pi-cog state-input-filter-settings-button"}
                ref={buttonRef}
            />

            {popUpOpen &&
                createPortal(
                    <div className={styles.popup} style={popUpPosition} ref={popUpRef}>
                        <Dropdown
                            className="prime-table-filter-input-font filter-popup"
                            value={filterType}
                            options={translatedOptions}
                            onChange={handleChangeFilterType}
                            optionLabel="label"
                            optionValue="value"
                            placeholder={`${t("Filter Type")}`}
                            name="filterType"
                        />
                    </div>,
                    tableRef.current
                )}
        </>
    );
};
